import { render, staticRenderFns } from "./TagTableList.vue?vue&type=template&id=5909dd31&"
import script from "./TagTableList.vue?vue&type=script&lang=ts&"
export * from "./TagTableList.vue?vue&type=script&lang=ts&"
import style0 from "./TagTableList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports